export const makeWebPageSchema = (params) => {
    return {
        '@type': 'WebPage',
        name: params.name,
        about: params.description,
        url: params.url,
        inLanguage: params.lang,
    };
};
